import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import TagGroup from '../models/TagGroup';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    tagGroups: [],
    allTagGroups: [],
    tagsByGroup: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    orderBy: undefined,
    orderByDesc: false,
    searchTerm: undefined,
    detail: {
        tagGroup: new TagGroup(),
    },
};


export default (state = initialState, action) => {
    switch (action.type) {
        case Types.TAG_GROUP_GET_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.TAG_GROUP_GET_ALL_SUCCESS:
            return { ...state, isFetching: false, allTagGroups: action.tagGroups };

        case Types.TAG_GROUP_GET_BY_TAG_GROUP_ACTION:
            return { ...state, isFetching: true };
        case Types.TAG_GROUP_GET_BY_TAG_GROUP_SUCCESS:
            return { ...state, isFetching: false, tagsByGroup: action.tagGroups };
    
        case Types.TAG_GROUP_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false };

        default:
            return state;
    }
}
